import { Pair } from '@/components/market/market';
import { memo, useCallback, useState } from 'react';
import SheetDetail from './sheet-detail';
import { useTranslation } from 'react-i18next';

type Props = {
    pairIndex: string;
    pairInfo: Pair | undefined;
    price24h: number;
};

const Detail = ({ pairIndex, pairInfo, price24h }: Props) => {
    const [isOpenDetail, setIsOpenDetail] = useState(false);
    const { t } = useTranslation();
    const handleToggleDetail = useCallback(() => {
        setIsOpenDetail((prev) => !prev);
    }, []);

    const handleClose = () => {
        setIsOpenDetail(false);
    };

    return (
        <>
            <div
                className="flex text-[#4C4C4C] text-sm"
                onClick={handleToggleDetail}
            >
                {`${t('Detail')} `}
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10.0009 13.9683C9.42172 13.9683 8.94922 14.4391 8.94922 15.0191C8.94922 15.5983 9.42172 16.0691 10.0009 16.0691C10.5801 16.0691 11.0517 15.5983 11.0517 15.0191C11.0517 14.4391 10.5801 13.9683 10.0009 13.9683Z"
                        fill="#4C4C4C"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10.0009 8.9502C9.42172 8.9502 8.94922 9.42103 8.94922 10.001C8.94922 10.5802 9.42172 11.051 10.0009 11.051C10.5801 11.051 11.0517 10.5802 11.0517 10.001C11.0517 9.42103 10.5801 8.9502 10.0009 8.9502Z"
                        fill="#4C4C4C"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10.0009 6.03296C10.5801 6.03296 11.0517 5.56213 11.0517 4.98213C11.0517 4.40296 10.5801 3.93213 10.0009 3.93213C9.42172 3.93213 8.94922 4.40296 8.94922 4.98213C8.94922 5.56213 9.42172 6.03296 10.0009 6.03296Z"
                        fill="#4C4C4C"
                    />
                </svg>
            </div>
            {isOpenDetail && (
                <SheetDetail
                    pairIndex={pairIndex}
                    pairInfo={pairInfo}
                    price24h={price24h}
                    isOpen={isOpenDetail}
                    onClose={handleClose}
                />
            )}
        </>
    );
};

export default memo(Detail);
